import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import { h5 } from '@helpers/typography';
import MotionTrack from '@stories/Components/Misc/Carousels/Carousel/MotionTrack/MotionTrack';
import MotionTrackStyles from '@stories/Components/Misc/Carousels/Carousel/MotionTrack/MotionTrack.styles';
import PaginationStyles from '@stories/Components/Misc/Carousels/Carousel/Pagination/Pagination.styles';
import HeadingSummaryBlockStyles from '@stories/Components/Misc/HeadingSummaryBlock/HeadingSummaryBlock.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  overflow: hidden;

  --sectionColour: ${brand.primary.blue.dark};

  ${HeadingSummaryBlockStyles.Container} {
    margin-bottom: ${fluid(40, 76)};

    @media ${until(Device.TabletLarge)} {
      text-align: center;
      align-items: center;
    }
  }

  @media print {
    display: none;
  }
`;
const Heading = styled.h3 `
  ${h5};

  margin-bottom: ${fluid(12, 30)};
  text-transform: uppercase;

  &:not(:first-of-type) {
    margin-top: ${fluid(56, 76)};
  }

  @media ${from(Device.Tablet)} {
    text-align: center;
  }
`;
const CarouselWrapper = styled.div `
  --itemPeek: 16px;
  --itemGutter: var(--gutterWidth, 12px);
  --visibleItems: 1;

  margin: 0 calc(var(--itemGutter) * -0.5);

  ${PaginationStyles.Container} {
    margin: 22px 0 0;

    @media ${from(Device.Tablet)} {
      display: none;
    }
  }

  @media ${from(Device.MobileLarge)} {
    --visibleItems: 2;
  }

  @media ${from(Device.TabletSmall)} {
    --visibleItems: 3;
  }

  @media ${from(Device.TabletLarge)} {
    --visibleItems: 4;
  }

  @media ${from(Device.DesktopSmall)} {
    --visibleItems: 6;
  }
`;
const Track = styled(MotionTrack) `
  @media ${from(Device.Tablet)} {
    ${MotionTrackStyles.Track} {
      row-gap: var(--itemGutter);
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`;
const Item = styled.li `
  display: block;
  flex: 0 0 calc(100% / var(--visibleItems) - (var(--itemPeek, 0px) / var(--visibleItems)));
  padding: 0 calc(var(--itemGutter) / 2);
`;
const BrandCardsStyles = {
    Container,
    Heading,
    Track,
    CarouselWrapper,
    Item,
};
export default BrandCardsStyles;
